import Flex from 'components/Flex'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'

export const RowNumberCandidateData = styled(Flex)`
  color: #3249d7;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 20.464px;
  justify-content: center;
  display: flex;
  align-items: center;
`

export const RowNumberCandidateDataEx = styled(Flex)`
  color: #3249d7;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 20.464px;
  display: flex;
`
export const RowNumberCandidateAlignCenter = styled(Flex)`
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  color: #343e59;
  align-items: center;
  justify-content: center;
  display: flex;
`
export const RowNumberOverAll = styled(Flex)`
  font-weight: ${FONT.FW_600};
  font-size: 15px;
  line-height: 20px;
  color: #5db594;
  align-items: center;
  justify-content: center;
  display: flex;
`
export const RowNumberCandidateAlignCenterItem = styled.div`
  justify-content: center;
  display: flex;
`
export const OverAllStatus = styled.div`
  background: #f9fafe;
  border-radius: 10px;
  border: 1px solid #d6dbf7;
  padding: 5px;
`
export const RowNumberData = styled(Flex)`
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_SM};
  line-height: 20px;
  color: ${COLORS.GREY_T_20};
  text-transform: capitalize;
`
export const RowNumberDataYr = styled(Flex)`
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_SM};
  line-height: 20px;
  color: ${COLORS.GREY_T_20};
`

export const RowNumberDataEx = styled(Flex)`
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_XS};
  line-height: 20px;
  color: ${COLORS.GREY_T_20};
  text-transform: capitalize;
`
export const RowNumberDataTitle = styled(Flex)`
  font-weight: 500;
  font-size: 0.75rem;
  line-height: 20px;
  color: #4d566e;
  text-transform: capitalize;
`
